/* eslint-disable camelcase */
import React from 'react'
import { CardListItem, Spacer, Link } from '@babylon/web-platform-ui'
import { Card } from '@babylon/medkit'
import { useFormatMessage } from '@babylon/intl'
import { getAge } from '@/utils'
import { EditFamilyMemberProps } from '@/types'
import { useConfig } from '@/redux/partnerConfig/selectors'
import messages from './FamilyMemberCard.messages'
import styles from './FamilyMemberCard.module.scss'

interface Props {
  onCardAction: () => void
  member: EditFamilyMemberProps
}

const FamilyMemberCard = ({ onCardAction, member }: Props) => {
  const translate = useFormatMessage()
  const { useDnaV2Design } = useConfig()

  const { first_name, last_name, date_of_birth } = member
  const age = getAge(date_of_birth!).toString()

  if (useDnaV2Design) {
    return (
      <CardListItem
        asButton
        onClick={onCardAction}
        rightElement={
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <Link
            as="span"
            data-testid="familyMemberCardAction"
            variant="standalone"
          >
            {translate(messages.edit)}
          </Link>
        }
      >
        {first_name} {last_name} <Spacer />{' '}
      </CardListItem>
    )
  }

  return (
    <Card
      data-testid="familyMemberCard"
      title={`${first_name} ${last_name} (${age})`}
      callToAction={
        <span
          data-testid="familyMemberCardAction"
          role="button"
          onClick={onCardAction}
          onKeyPress={onCardAction}
          tabIndex={0}
          className={styles.FamilyMemberCard_edit}
        >
          {translate(messages.edit)}
        </span>
      }
    />
  )
}

export default FamilyMemberCard
